<template>
  <div>
    <div class="loading-state-container" v-if="loadUserState.isLoading">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div v-if="!loadUserState.isLoading">
      <Page v-if="!loadUserState.error">
        <template v-slot:page-header>
          <div class="container">
            <div class="page-header">
              <router-link
                class="btn btn-action btn-action-back"
                :to="'/accounts'">
                <i class="fas fa-chevron-left" />
              </router-link>
              <div class="title-container">
                <div class="subtitle">แก้ไขข้อมูลผู้ใช้</div>
                <div class="title">{{getUserName()}}</div>
              </div>
              <div class="actions">
                <small class="text-danger mr-3" v-if="isServerError()">
                  {{getErrorMessageFromErrorStatus(errorStatus)}}
                </small>
                <button
                  :disabled= '!isValid'
                  type="submit"
                  @click.stop="updateUser"
                  class="btn btn-primary">
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        </template>
        <div class="container">
          <div class="section-container">
            <UserEditForm
              :user.sync="user"
              :saveUserStateError.sync="saveUserState.error"/>
          </div>
        </div>
      </Page>
    </div>
    <!-- error from api -->
    <ErrorMessageUserContainer
      v-if="loadUserState.error"
      :error="loadUserState.error"
      :redirectLink="'/accounts'"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

import _ from 'lodash';
import { mapGetters } from 'vuex';
import Page from '@/layouts/Page.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

import {
  loadUserById,
  updateUserByAccountId,
} from './api';
import UserEditForm from './UserEditForm.vue';
import ErrorMessageUserContainer from './ErrorMessageUserContainer.vue';

export default {
  components: {
    Page,
    PreloaderSection,
    UserEditForm,
    ErrorMessageUserContainer,
  },
  data() {
    return {
      user: null,
      userOldName: null,
      loadUserState: {
        isLoading: true,
        error: null,
      },
      saveUserState: {
        error: {
          name: null,
        },
      },
      errorStatus: null,
    };
  },
  created() {
    this.load(this.accountId);
  },
  computed: {
    ...mapGetters(['currentUser']),
    isCurrentUserEditing() {
      const currentUserId = _.get(this.currentUser, 'id', this.currentUser._id);
      return currentUserId === this.user.id;
    },
    accountId() {
      return this.$route.params.accountId;
    },
    isValid() {
      return this.user.name
      && (_.every(this.saveUserState.error, _.isEmpty));
    },
  },
  methods: {
    async load(accountId) {
      this.loadUserState.isLoading = true;
      try {
        const userResponse = await loadUserById(accountId);
        this.user = userResponse.data;
        this.userOldName = this.user.name;
        this.loadUserState.isLoading = false;
      } catch (error) {
        this.loadUserState.error = error.response;
        this.loadUserState.isLoading = false;
      }
    },
    async updateUser() {
      try {
        await updateUserByAccountId(
          this.accountId,
          this.user,
        );
        this.errorStatus = null;
        if (this.isCurrentUserEditing) {
          this.$store.dispatch('setCurrentUser', this.user);
          if (this.user.roleId === 'editor') {
            this.$router.push('/');
            return;
          }
        }
        this.$router.push('/accounts');
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveUserState.error = error.response;
      }
    },
    isServerError() {
      return this.errorStatus;
    },
    getUserName() {
      return this.userOldName ? this.userOldName : this.accountId;
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500 || errorStatus === 404) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422 || errorStatus === 409) {
        return 'กรอกข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.loading-state-container {
  margin-top: $spacer * 6;
}
</style>
